import { Box, Divider,styled } from "@mui/material";

import AlignmentButtons from "./toolbar/AlignmentButtons";
import EmojiPickerPopover from "./toolbar/EmojiPickerPopover";
import FormatDropdown from "./toolbar/FormatDropdown";
import LinkPopover from "./toolbar/LinkPopover";
import ListButtons from "./toolbar/ListButtons";
import TextStyleButtons from "./toolbar/TextStyleButtons";
import UnifiedColorPicker from "./toolbar/UnifiedColorPicker";

const ToolbarContainer = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	flexWrap: "nowrap",
	alignItems: "center",
	overflowX: "hidden",
	borderBottom: `1px solid ${theme.palette.divider}`,
	paddingBottom: theme.spacing(1),
	marginBottom: theme.spacing(1),
	marginTop: theme.spacing(1),
	gap: theme.spacing(0.5),
}));

const EditorToolbar = ({ editor, currentFormat, setCurrentFormat, onLinkPopoverOpen }) => {
	if (!editor) return null;

	return (
		<ToolbarContainer className="tiptap-toolbar">
			<FormatDropdown 
				editor={editor} 
				currentFormat={currentFormat} 
				setCurrentFormat={setCurrentFormat} 
			/>

			<TextStyleButtons editor={editor} />

			<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
			<UnifiedColorPicker editor={editor} type="highlight" iconOnly={true} />
			<UnifiedColorPicker editor={editor} type="text" />

			<EmojiPickerPopover editor={editor} />
			
			<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
			<ListButtons editor={editor} />
			
			<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
			<AlignmentButtons editor={editor} />
			
			<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
			<LinkPopover editor={editor} onLinkPopoverOpen={onLinkPopoverOpen} />
		</ToolbarContainer>
	);
};

export default EditorToolbar;